<template>
  <md-content>

    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-55">
        <md-datepicker v-model="dateLogs" @md-closed="getLogsByDate" :md-model-type="String">
          <label>Дата</label>
        </md-datepicker>
      </div>
      <div class="md-layout-item md-size-25">
        <md-switch v-model="filters.open" class="md-primary">Фильтры</md-switch>
      </div>
    </div>

    <div v-if="filters.open">
      <md-field>
        <label>Статус</label>
        <md-select v-model="filters.success">
          <md-option value="all" selected>Все</md-option>
          <md-option value="success">Успешные</md-option>
          <md-option value="nosuccess">Не успешные</md-option>
        </md-select>
      </md-field>

      <md-field v-if="user && (user.role === 'admin'|| user.role === 'manager')">
        <label>Пользователь: </label>
        <md-select v-model="filters.userID">
          <md-option value="0" selected>Все</md-option>
          <md-option v-for="user in users" :value="user.id">{{user.name}}</md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Поиск по номеру заказа: </label>
        <md-input v-model="filters.oderNumber"/>
      </md-field>

      <div class="md-layout md-gutter">
        <md-field class="md-layout-item md-size-25">
          <label class="md-title">Время: </label>
        </md-field>
        <md-field class="md-layout-item md-size-25">
          <label>С</label>
          <md-select v-model="filters.time.from">
            <md-option value="nope" selected>-</md-option>
            <md-option v-for="n in 25" :value="n-1">{{n-1}}</md-option>
          </md-select>
        </md-field>

        <md-field class="md-layout-item md-size-5">
          <label> : </label>
        </md-field>

        <md-field class="md-layout-item md-size-25">
          <label>ПО</label>
          <md-select v-model="filters.time.by" v-if="filters.time.from > 0">
            <md-option value="nope" selected>-</md-option>
            <md-option v-for="n in 25-filters.time.from" :value="filters.time.from+n-1">{{filters.time.from+n-1}}
            </md-option>
          </md-select>
        </md-field>
      </div>

    </div>

    <md-card v-for="log in SetStatusEvents">
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">{{log.order_id}} <span class="md-subhead">Время: {{parseTime(log.time)}}</span></div>
          <div class="md-body-2" v-if="user && (user.role === 'admin'|| user.role === 'manager')">Установил:
            {{log.user.name}}
          </div>
        </md-card-header-text>
      </md-card-header>

      <md-card-content>
        <md-content v-if="log.meta.order">
          <span>Адрес:</span>
          <span>{{log.meta.order.DeliveryStreet}}</span>
        </md-content>
        <br>
        <md-content>
          <span>Статус:</span>
          <span>{{statusName(log.event_type)}}</span>
        </md-content>
        <md-content>
          <span>Результат:</span>
          <span v-if="success(log.meta.error)==='успешно'" style="color: green">{{success(log.meta.error)}}</span>
          <span v-else style="color: red">{{success(log.meta.error)}}</span>
        </md-content>
      </md-card-content>
    </md-card>
  </md-content>
</template>

<script>
  export default {
    name: "UserLogs",
    data() {
      return {
        dateLogs: '',
        filters: {
          open: false,
          success: 'all',
          oderNumber: '',
          userID: 0,
          time: {
            from: 'nope',
            by: 'nope',
          }
        }
      }
    },
    mounted() {
      this.dateLogs = new Date().toISOString().substring(0, 10); // vue ругается на это но дата пикер всеравно работает исправно
      this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
        event: 'getAllLogsByDate',
        date: this.dateLogs,
      }));
      this.$material.locale.firstDayOfAWeek = 1;
      this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
        event: 'getAllUsers',
      }))
    },
    computed: {
      SetStatusEvents() {
        let filterLogs = [];
        let logs = this.$store.getters.getLogsByTypes(['SetDoneStatus', 'SetDonePartStatus', 'SetDeniedStatus', 'ShiftOrder']);

        for (let i in logs) {
          if (!logs.hasOwnProperty(i)) continue;

          if (!this.filters.open) {
            filterLogs.push(logs[i]);
            continue
          }

          if (this.filters.time.from !== "nope" && this.filters.time.by !== "nope") {
            let date = new Date(logs[i].time);
            console.log(date.getHours() <= this.filters.time.from, date.getHours() >= this.filters.time.by)
            if (date.getHours() < this.filters.time.from || date.getHours() > this.filters.time.by) {
              console.log(this.filters.time, date.getHours());
              continue
            }
          }

          if (Number(this.filters.userID) !== 0 && Number(this.filters.userID) !== logs[i].user.id){
            continue
          }

          if (!String(logs[i].order_id).includes(this.filters.oderNumber)) continue;

          if (this.filters.success === "all") {
            filterLogs.push(logs[i]);
            continue
          }

          if (logs[i].meta.error === "" && (this.filters.success === "success")) {
            filterLogs.push(logs[i]);
            continue;
          }

          if (logs[i].meta.error !== "" && (this.filters.success === "nosuccess")) {
            filterLogs.push(logs[i]);
          }
        }

        filterLogs.sort(function (a, b) {
          return new Date(b.time) - new Date(a.time);
        });

        return filterLogs;
      },
      user() {
        return this.$store.getters.getUser
      },
      users: function () {
        return this.$store.getters.getUsers
      },
    },
    methods: {
      getLogsByDate() {
        let app = this;
        setTimeout(function () {
          // почемуто v-model="dateLogs" срабатывает ПОСЛЕ метода и отлетает старое значение console.log(app.dateLogs), поэтому тут этот сет таймаут
          app.$store.getters.getWSConnectState.ws.send(JSON.stringify({
            event: 'getAllLogsByDate',
            date: app.dateLogs,
          }));
        });
      },
      parseTime(time) {
        let date = new Date(time);
        let minutes = date.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return date.getHours() + ":" + minutes
      },
      statusName(statusEvent) {
        if (statusEvent === 'SetDoneStatus') return 'Полностью выполнен';
        if (statusEvent === 'SetDonePartStatus') return 'Частично выполнен';
        if (statusEvent === 'SetDeniedStatus') return 'Отказ';
        if (statusEvent === 'ShiftOrder') return 'Перенос';
        return ``
      },
      success(err) {
        if (err === "") {
          return 'успешно'
        } else {
          return 'неуспешно'
        }
      }
    },
  }
</script>

<style scoped>
  .md-card {
    width: 240px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
    word-wrap: break-word;
  }

  .md-card-content {
    padding-left: 0;
  }

  .md-switch {
    margin: 25px 16px 16px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserLogs.vue